import CycleSettings from '../enums/cycle-setting.enum';

export const CHANNELS = {
  'C-1': 'channel 1',
  'C-2': 'channel 2',
  'C-3': 'channel 3',
  'C-4': 'channel 4',
  'C-5': 'channel 5',
  'C-6': 'channel 6',
  'C-7': 'channel 7',
  'C-8': 'channel 8',
  'C-9': 'channel 9',
  'C-10': 'channel 10',
  'C-11': 'channel 11',
  'C-12': 'channel 12',
  'C-13': 'channel 13',
  'C-14': 'channel 14',
  'C-15': 'channel 15',
  'C-16': 'channel 16',
  'C-17': 'channel 17',
  'C-18': 'channel 18',
  'C-19': 'channel 19',
  'C-20': 'channel 20',
  'C-21': 'channel 21',
  'C-22': 'channel 22',
  'C-23': 'channel 23',
  'C-24': 'channel 24',
};

export const THERMOCOUPLES = {
  'TC-1': 'thermo 1',
  'TC-2': 'thermo 2',
  'TC-3': 'thermo 3',
  'TC-4': 'thermo 4',
  'TC-5': 'thermo 5',
  'TC-6': 'thermo 6',
  'TC-7': 'thermo 7',
  'TC-8': 'thermo 8',
  'TC-9': 'thermo 9',
  'TC-10': 'thermo 10',
  'TC-11': 'thermo 11',
  'TC-12': 'thermo 12',
  'TC-13': 'thermo 13',
  'TC-14': 'thermo 14',
  'TC-15': 'thermo 15',
  'TC-16': 'thermo 16',
  'TC-17': 'thermo 17',
  'TC-18': 'thermo 18',
  'TC-19': 'thermo 19',
  'TC-20': 'thermo 20',
  'TC-21': 'thermo 21',
  'TC-22': 'thermo 22',
  'TC-23': 'thermo 23',
  'TC-24': 'thermo 24',
};

export const CYCLE_DATA_NAMES = {
  NAME: 'name',
  LOCATION: 'location',
  CONTRACT: 'contract',
  LIST: 'list',
};

export const MODE_BY_NUMBER = {
  1: CycleSettings.PostWeld,
  2: CycleSettings.PreHeat,
  3: CycleSettings.PercentageTimer,
  4: CycleSettings.Recorder,
}
